import { render } from "./ApplyToCollaborateMessage.vue.js?vue&type=template&id=d3082636!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ApplyToCollaborateMessage.vue?vue&type=template&id=d3082636"
import script from "./ApplyToCollaborateMessage.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ApplyToCollaborateMessage.vue?vue&type=script&lang=js"
export * from "./ApplyToCollaborateMessage.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ApplyToCollaborateMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/apply-to-collaborate-page/ApplyToCollaborateMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d3082636"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d3082636', __exports__)) {
    api.reload('d3082636', __exports__)
  }
  
  module.hot.accept("./ApplyToCollaborateMessage.vue.js?vue&type=template&id=d3082636!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ApplyToCollaborateMessage.vue?vue&type=template&id=d3082636", () => {
    api.rerender('d3082636', render)
  })

}


export default __exports__